import React, { Fragment } from 'react';

export default function IconUser(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0.988118C5.65216 0.988118 4.55953 2.08076 4.55953 3.42859C4.55953 4.77643 5.65216 5.86907 7 5.86907C8.34784 5.86907 9.44048 4.77643 9.44048 3.42859C9.44048 2.08076 8.34784 0.988118 7 0.988118ZM3.72619 3.42859C3.72619 1.62052 5.19193 0.154785 7 0.154785C8.80808 0.154785 10.2738 1.62052 10.2738 3.42859C10.2738 5.23667 8.80808 6.7024 7 6.7024C5.19193 6.7024 3.72619 5.23667 3.72619 3.42859ZM1.82793 9.68509C2.44188 9.07113 3.27459 8.72621 4.14286 8.72621H9.85714C10.7254 8.72621 11.5581 9.07113 12.1721 9.68509C12.786 10.299 13.131 11.1318 13.131 12V13.4286C13.131 13.6587 12.9444 13.8453 12.7143 13.8453C12.4842 13.8453 12.2976 13.6587 12.2976 13.4286V12C12.2976 11.3528 12.0405 10.732 11.5828 10.2743C11.1251 9.81667 10.5044 9.55955 9.85714 9.55955H4.14286C3.4956 9.55955 2.87486 9.81667 2.41718 10.2743C1.9595 10.732 1.70238 11.3528 1.70238 12V13.4286C1.70238 13.6587 1.51583 13.8453 1.28572 13.8453C1.0556 13.8453 0.869049 13.6587 0.869049 13.4286V12C0.869049 11.1318 1.21397 10.299 1.82793 9.68509Z"
        fill={
          props.bgded
            ? props.color
              ? props.color
              : props?.wl?.cor_texto_botao
            : props.color
            ? props.color
            : props?.wl?.cor_tema_secundaria
        }
      />
    </svg>
  );
}
